var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c("booking-tree-grid", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "list",
            expression: "view==='list'"
          }
        ],
        ref: "bookingTreeGrid",
        attrs: {
          "is-fba": _vm.isFba,
          context: _vm.context,
          "is-query": _vm.isQuery
        },
        on: {
          look: _vm.lookHandle,
          add: _vm.addHandle,
          edit: _vm.editHandle,
          split: _vm.splitHandle,
          copy: _vm.copyHandle
        }
      }),
      _c("booking-workspace", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "detail",
            expression: "view==='detail'"
          }
        ],
        ref: "bookingWorkspace",
        attrs: {
          "is-fba": _vm.isFba,
          "parent-context": _vm.context,
          view: _vm.view
        },
        on: { copy: _vm.copyHandle, back: _vm.backToList, add: _vm.addHandle }
      }),
      _c("job-copy-window", {
        attrs: {
          visible: _vm.copyDialog.visible,
          lob: _vm.copyDialog.job.lob || ""
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.copyDialog, "visible", $event)
          },
          confirmCallBack: _vm.confirmCallBackHandler
        }
      }),
      _c("job-no-rule-selector", {
        attrs: {
          visible: _vm.jobNoRule.visible,
          rules: _vm.jobNoRule.rules || []
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.jobNoRule, "visible", $event)
          },
          selectedBack: _vm.doCopyJob
        }
      }),
      _vm.jobLobDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              staticClass: "app-main-inner",
              attrs: {
                visible: _vm.jobLobDialog.visible,
                title: _vm.$t("CargoMsg.Cargo_BusinessType"),
                width: _vm.$selectByLang(
                  "300px",
                  "300px",
                  "300px",
                  "400px",
                  "400px",
                  "400px"
                ),
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.jobLobDialog, "visible", $event)
                },
                close: function($event) {
                  _vm.jobLobDialog.visible = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: {
                    "flex-direction": "column",
                    "padding-bottom": "10px"
                  }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.jobLobDialog.lob,
                        callback: function($$v) {
                          _vm.$set(_vm.jobLobDialog, "lob", $$v)
                        },
                        expression: "jobLobDialog.lob"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { no: "RE", label: "RE" } }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Export")))
                      ]),
                      _c(
                        "el-radio",
                        {
                          staticStyle: { "margin-left": "-20px" },
                          attrs: { no: "RI", label: "RI" }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_JobTypeImport")))]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "Confirm", type: "primary" },
                      on: { click: _vm.confirmJobLovHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmR")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "Cancel" },
                      on: {
                        click: function() {
                          this$1.jobLobDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }